import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ViewListIcon from '@mui/icons-material/ViewList';
import { ToggleButton, Tooltip } from '@mui/material';
import { StyledToggleButtonGroup } from './styles';

export type ViewType = 'table' | 'calendar';

interface ViewToggleProps {
  view: ViewType;
  onChange: (view: ViewType) => void;
}

const ViewToggle = ({ view, onChange }: ViewToggleProps) => {
  const handleChange = (_event: React.MouseEvent<HTMLElement>, newView: ViewType | null) => {
    if (newView !== null) {
      onChange(newView);
    }
  };

  return (
    <StyledToggleButtonGroup
      value={view}
      exclusive
      onChange={handleChange}
      aria-label="view toggle"
      size="small"
    >
      <Tooltip title="Calendar View" arrow placement="top">
        <ToggleButton value="calendar" aria-label="calendar view">
          <CalendarMonthIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
      <Tooltip title="Table View" arrow placement="top">
        <ToggleButton value="table" aria-label="table view">
          <ViewListIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
    </StyledToggleButtonGroup>
  );
};

export default ViewToggle;

